import React, { useState } from "react";
import styles from "./property-images.module.scss";
import { Dialog } from "primereact/dialog";
import GridGallary from "./GridGallary";
import {
  PropertyDetailImageClick,
  TotalPropertyImageViewed
} from "../../investor/amplitude";
import { useSearchParams } from "react-router-dom";
import useContextHook from "../../../hooks/context/useContext";

const PropertyImages = ({
  imagesArr,
  propertyId,
  type,
  objPropertyDetails
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mobileNumber } = useContextHook();
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  const [imageViewCount, setImageViewCount] = useState(0);
  const Fullscreen = () => {
    if (imagesArr) {
      setIsOpen(true);
    }
  };
  const closeDialog = () => {
    if (type === "investor") {
      TotalPropertyImageViewed({
        totalImagesViewed: imageViewCount,
        propertyId: objPropertyDetails?.propertyId,
        opportunitySFID: objPropertyDetails?.opportunitySFID,
        pubPropertySFID: objPropertyDetails?.pubPropertySFID,
        propertySFID: objPropertyDetails?.propertySFID,
        shareId: propertyId || "",
        linkCId: cid,
        linkEmailId: eq,
        ...(mobileNumber && { mobileNumber: mobileNumber })
      });
    }
  };

  const isVideo = (url: string) => {
    return url?.match(/\.(mp4|mov|avi|wmv|flv|mkv)$/i) ? true : false;
  };

  const renderMedia = (media: any, index: number, array: any) => {
    const isVideoFile = isVideo(media?.url);
    if (isVideoFile) {
      return (
        <video
          key={index}
          className={styles.mediaContent}
          autoPlay
          muted
          loop
          playsInline
          onClick={() => {
            Fullscreen();
            if (type === "investor") {
              PropertyDetailImageClick({
                image_url: media?.url,
                propertyId: objPropertyDetails?.propertyId,
                opportunitySFID: objPropertyDetails?.opportunitySFID,
                pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                propertySFID: objPropertyDetails?.propertySFID,
                shareId: propertyId,
                linkCId: cid,
                linkEmailId: eq,
                ...(mobileNumber && { mobileNumber: mobileNumber })
              });
            }
          }}
        >
          <source src={media?.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }

    return (
      <img
        key={index}
        src={media?.url}
        alt="Media"
        className={styles.mediaContent}
        onClick={() => {
          Fullscreen();
          if (type === "investor") {
            PropertyDetailImageClick({
              image_url: media?.url,
              propertyId: objPropertyDetails?.propertyId,
              opportunitySFID: objPropertyDetails?.opportunitySFID,
              pubPropertySFID: objPropertyDetails?.pubPropertySFID,
              propertySFID: objPropertyDetails?.propertySFID,
              shareId: propertyId,
              linkCId: cid,
              linkEmailId: eq,
              ...(mobileNumber && { mobileNumber: mobileNumber })
            });
          }
        }}
      />
    );
  };

  return (
    <div className={styles.wrapImg}>
      {imagesArr?.length > 0 ? (
        imagesArr?.length < 3 ? (
          imagesArr?.map((media: any, index: number, array: any) => {
            return (
              <div
                className={array?.length === 1 ? styles.full : styles.half}
                tabIndex={1}
                key={index}
              >
                {renderMedia(media, index, array)}
                <Dialog
                  visible={isOpen}
                  onHide={() => {
                    if (!isOpen) return;
                    setIsOpen(false);
                    closeDialog();
                  }}
                  draggable={false}
                  className={`${styles.full_screen_dialog} ${
                    array?.length === 1 ? styles.full_screen_dialog1 : ""
                  }`}
                  headerClassName={styles.customDialogHeader}
                  contentClassName={styles.customDialogContent}
                  dismissableMask={true}
                >
                  <GridGallary
                    setImageViewCount={setImageViewCount}
                    imagesArr={imagesArr}
                    objPropertyDetails={objPropertyDetails}
                  />
                </Dialog>
              </div>
            );
          })
        ) : (
          <>
            {imagesArr?.length < 4 ? (
              imagesArr?.length === 3 ? (
                <div className={styles.threeImg}>
                  <div className={styles.propertyImage1} tabIndex={1}>
                    {renderMedia(imagesArr[0], 0, imagesArr)}
                  </div>
                  <div className={styles.propertyTwoImgWrap}>
                    {renderMedia(imagesArr[1], 1, imagesArr)}
                    {renderMedia(imagesArr[2], 2, imagesArr)}
                  </div>
                  <Dialog
                    visible={isOpen}
                    onHide={() => {
                      if (!isOpen) return;
                      setIsOpen(false);
                      closeDialog();
                    }}
                    draggable={false}
                    className={styles.full_screen_dialog}
                    headerClassName={styles.customDialogHeader}
                    contentClassName={styles.customDialogContent}
                    dismissableMask={true}
                  >
                    <GridGallary
                      setImageViewCount={setImageViewCount}
                      imagesArr={imagesArr}
                      objPropertyDetails={objPropertyDetails}
                    />
                  </Dialog>
                </div>
              ) : (
                <div
                  style={{ display: "flex", gap: "10px" }}
                  className={styles.half2}
                  tabIndex={1}
                >
                  {renderMedia(imagesArr[0], 0, imagesArr)}
                  {renderMedia(imagesArr[1], 1, imagesArr)}
                  <Dialog
                    visible={isOpen}
                    onHide={() => {
                      if (!isOpen) return;
                      setIsOpen(false);
                      closeDialog();
                    }}
                    draggable={false}
                    className={styles.full_screen_dialog}
                    headerClassName={styles.customDialogHeader}
                    contentClassName={styles.customDialogContent}
                    dismissableMask={true}
                  >
                    <GridGallary
                      setImageViewCount={setImageViewCount}
                      imagesArr={imagesArr}
                      objPropertyDetails={objPropertyDetails}
                    />
                  </Dialog>
                </div>
              )
            ) : (
              <>
                <div className={styles.propertyBig} tabIndex={1}>
                  {renderMedia(imagesArr[0], 0, imagesArr)}
                </div>
                <div className={styles.propertySmall}>
                  <div className={styles.imgWrap}>
                    {renderMedia(imagesArr[1], 1, imagesArr)}
                  </div>
                  <div className={styles.imgWrap}>
                    {renderMedia(imagesArr[2], 2, imagesArr)}
                  </div>
                  <div className={styles.imgWrap}>
                    {renderMedia(imagesArr[3], 3, imagesArr)}
                  </div>
                  <div
                    className={`${styles.imgWrap} ${styles.galleryImg}`}
                    tabIndex={3}
                  >
                    <Dialog
                      dismissableMask={true}
                      visible={isOpen}
                      onHide={() => {
                        if (!isOpen) return;
                        setIsOpen(false);
                        closeDialog();
                      }}
                      className={styles.full_screen_dialog}
                      headerClassName={styles.customDialogHeader}
                      contentClassName={styles.customDialogContent}
                    >
                      <GridGallary
                        setImageViewCount={setImageViewCount}
                        imagesArr={imagesArr}
                        objPropertyDetails={objPropertyDetails}
                      />
                    </Dialog>
                    {renderMedia(imagesArr[4], 4, imagesArr)}
                    {imagesArr?.length > 5 && (
                      <div className={styles.imgCaption} onClick={Fullscreen}>
                        {`+${imagesArr?.length - 5} Photos`}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )
      ) : (
        <div className={styles.full}>
          <img src="/images/no-img-details.png" alt="user" />
          <span
            className={styles.notFound}
            onClick={() => {
              if (type === "investor") {
                PropertyDetailImageClick({
                  image_url: "/images/no-img-details.png",
                  propertyId: objPropertyDetails?.propertyId,
                  opportunitySFID: objPropertyDetails?.opportunitySFID,
                  pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                  propertySFID: objPropertyDetails?.propertySFID,
                  shareId: propertyId,
                  linkCId: cid,
                  linkEmailId: eq,
                  ...(mobileNumber && { mobileNumber: mobileNumber })
                });
              }
            }}
          >
            Images Not Found
          </span>
        </div>
      )}
    </div>
  );
};

export default React.memo(PropertyImages);
